// Other imports
import type { FC, SVGProps } from 'react';
import cn from '@/ui/utils/cn/cn';
// Icon imports
import IconApple from './icons/apple.svg';
import IconArrowLeft from './icons/arrow-left.svg';
import IconArrowPointer from './icons/arrow-pointer.svg';
import IconArrowRight from './icons/arrow-right.svg';
import IconArrowRightFromBracket from './icons/arrow-right-from-bracket.svg';
import IconArrowRotateLeft from './icons/arrow-rotate-left.svg';
import IconArrowUpRight from './icons/arrow-up-right.svg';
import IconAtomSimple from './icons/atom-simple.svg';
import IconAward from './icons/award.svg';
import IconBag from './icons/bag.svg';
import IconBagsShopping from './icons/bags-shopping.svg';
import IconBarcodeRead from './icons/barcode-read.svg';
import IconBell from './icons/bell.svg';
import IconBolt from './icons/bolt.svg';
import IconBookOpen from './icons/book-open.svg';
import IconBookingCalendarDay from './icons/booking-calendar-day.svg';
import IconBookingUser from './icons/booking-user.svg';
import IconBox from './icons/box.svg';
import IconBoxCheck from './icons/box-check.svg';
import IconBoxTaped from './icons/box-taped.svg';
import IconBullseye from './icons/bullseye.svg';
import IconCalendar from './icons/calendar.svg';
import IconCalm from './icons/calm.svg';
import IconCart from './icons/cart.svg';
import IconCheck from './icons/check.svg';
import IconChevronLeft from './icons/chevron-left.svg';
import IconChevronRight from './icons/chevron-right.svg';
import IconCircleCheck from './icons/circle-check.svg';
import IconCircleExclamation from './icons/circle-exclamation.svg';
import IconInfo from './icons/circle-info.svg';
import IconCircleQuestion from './icons/circle-question.svg';
import IconCircleUser from './icons/circle-user.svg';
import IconCircleXmark from './icons/circle-xmark.svg';
import IconClockThree from './icons/clock-three.svg';
import IconClose from './icons/close.svg';
import IconCommentQuestion from './icons/comment-question.svg';
import IconDownToLine from './icons/down-to-line.svg';
import IconDropdown from './icons/dropdown.svg';
import IconEnvelope from './icons/envelope.svg';
import IconExpand from './icons/expand.svg';
import IconEye from './icons/eye.svg';
import IconEyeSlash from './icons/eye-slash.svg';
import IconFeather from './icons/feather.svg';
import IconFlaskVial from './icons/flask-vial.svg';
import IconGear from './icons/gear.svg';
import IconGlobe from './icons/globe.svg';
import IconGoogle from './icons/google.svg';
import IconGrid from './icons/grid.svg';
import IconHeadspace from './icons/headspace.svg';
import IconHouse from './icons/house.svg';
import IconImage from './icons/image.svg';
import IconInsightTimer from './icons/insight-timer.svg';
import IconLeaf from './icons/leaf.svg';
import IconLightCart from './icons/light-cart.svg';
import IconLightCircleUser from './icons/light-circle-user.svg';
import IconLightGlobe from './icons/light-globe.svg';
import IconLineArrowRight from './icons/line-arrow-right.svg';
import IconLinkSlash from './icons/link-slash.svg';
import IconListCheck from './icons/list-check.svg';
import IconLocationDot from './icons/location-dot.svg';
import IconLock from './icons/lock.svg';
import IconMenu from './icons/menu.svg';
import IconMinus from './icons/minus.svg';
import IconMobile from './icons/mobile.svg';
import IconMoon from './icons/moon.svg';
import IconMusicMagnifyingGlass from './icons/music-magnifying-glass.svg';
import IconMindOasis from './icons/new-app-logo.svg';
import IconPause from './icons/pause.svg';
import IconPaymentMethodAbn from './icons/payment-methods/abn.svg';
import IconPaymentMethodAmex from './icons/payment-methods/amex.svg';
import IconPaymentMethodBancontact from './icons/payment-methods/bancontact.svg';
import IconPaymentMethodIdeal from './icons/payment-methods/ideal.svg';
import IconPaymentMethodIng from './icons/payment-methods/ing.svg';
import IconPaymentMethodMaestro from './icons/payment-methods/maestro.svg';
import IconPaymentMethodMastercard from './icons/payment-methods/mastercard.svg';
import IconPaymentMethodRabobank from './icons/payment-methods/rabobank.svg';
import IconPaymentMethodTrustly from './icons/payment-methods/trustly.svg';
import IconPaymentMethodVisa from './icons/payment-methods/visa.svg';
import IconPen from './icons/pen.svg';
import IconPlay from './icons/play.svg';
import IconPlugCircleCheck from './icons/plug-circle-check.svg';
import IconPlus from './icons/plus.svg';
import IconPowerOff from './icons/power-off.svg';
import IconPowerOffLight from './icons/power-off-light.svg';
import IconQuoteLeft from './icons/quote-left.svg';
import IconQuoteRight from './icons/quote-right.svg';
import IconReply from './icons/reply.svg';
import IconRulerCombined from './icons/ruler-combined.svg';
import IconSearch from './icons/search.svg';
import IconSignIn from './icons/sign-in.svg';
import IconSignalStream from './icons/signal-stream.svg';
import IconSlidersSimple from './icons/sliders-simple.svg';
import IconSocialFacebook from './icons/social/facebook.svg';
import IconSocialInstagram from './icons/social/instagram.svg';
import IconSocialTwitter from './icons/social/twitter.svg';
import IconSocialYoutube from './icons/social/youtube.svg';
import IconSpa from './icons/spa.svg';
import IconSpaLight from './icons/spa-light.svg';
import IconStarEmpty from './icons/star-empty.svg';
import IconStarFilled from './icons/star-filled.svg';
import IconsStars from './icons/stars.svg';
import IconTag from './icons/tag.svg';
import IconTagFilled from './icons/tag-filled.svg';
import IconTrash from './icons/trash.svg';
import IconTriangleExclamation from './icons/triangle-exclamation.svg';
import IconUser from './icons/user.svg';
import IconUserIcon from './icons/user-icon.svg';
import IconUserMagnifyingGlass from './icons/user-magnifying-glass.svg';
import IconUserMusician from './icons/user-music.svg';
import IconVolume from './icons/volume.svg';
import IconVolumeXMark from './icons/volume-xmark.svg';
import IconWaveSine from './icons/wave-sine.svg';
import IconWaveform from './icons/waveform.svg';
import IconXMark from './icons/x-mark.svg';
// Images imports
import ImageAmex from './images/amex.svg';
import ImageBCorporationBadge from './images/b-corporation-badge.svg';
import ImageGoogleLogo from './images/google-logo.svg';
import ImageIdeal from './images/ideal.svg';
import ImageLogo from './images/logo.svg';
import ImageLogoHome from './images/logo-home.svg';
import ImageMastercard from './images/mastercard.svg';
import ImagePayPal from './images/paypal.svg';
import ImageRitualsCtaIcon from './images/rituals-cta-icon.svg';
import ImageRitualsPrimaryLogo from './images/rituals-primary-logo.svg';
import ImageVisa from './images/visa.svg';
import ImageVogue from './images/vogue.svg';

// Icons
const icons = {
  'icon-booking-calendar-day': IconBookingCalendarDay,
  'icon-booking-user': IconBookingUser,
  'icon-calendar': IconCalendar,
  'icon-calm': IconCalm,
  'icon-clock': IconClockThree,
  'icon-tag': IconTag,
  'icon-tag-filled': IconTagFilled,
  'icon-atom': IconAtomSimple,
  'icon-bell': IconBell,
  'icon-cart': IconCart,
  'icon-close': IconClose,
  'icon-book-open': IconBookOpen,
  'icon-globe': IconGlobe,
  'icon-menu': IconMenu,
  'icon-arrow-right': IconArrowRight,
  'icon-arrow-right-from-bracket': IconArrowRightFromBracket,
  'icon-arrow-up-right': IconArrowUpRight,
  'icon-gear': IconGear,
  'icon-user': IconUser,
  'icon-user-icon': IconUserIcon,
  'icon-mobile': IconMobile,
  'icon-box': IconBox,
  'icon-grid': IconGrid,
  'icon-payment-method-abn': IconPaymentMethodAbn,
  'icon-payment-method-ideal': IconPaymentMethodIdeal,
  'icon-payment-method-mastercard': IconPaymentMethodMastercard,
  'icon-payment-method-trustly': IconPaymentMethodTrustly,
  'icon-payment-method-visa': IconPaymentMethodVisa,
  'icon-payment-method-amex': IconPaymentMethodAmex,
  'icon-payment-method-bancontact': IconPaymentMethodBancontact,
  'icon-payment-method-ing': IconPaymentMethodIng,
  'icon-payment-method-maestro': IconPaymentMethodMaestro,
  'icon-payment-method-rabobank': IconPaymentMethodRabobank,
  'icon-social-facebook': IconSocialFacebook,
  'icon-social-twitter': IconSocialTwitter,
  'icon-social-youtube': IconSocialYoutube,
  'icon-social-instagram': IconSocialInstagram,
  'icon-star-filled': IconStarFilled,
  'icon-star-empty': IconStarEmpty,
  'icon-feather': IconFeather,
  'icon-spa': IconSpa,
  'icon-spa-light': IconSpaLight,
  'icon-stars': IconsStars,
  'icon-flask-vial': IconFlaskVial,
  'icon-circle-user': IconCircleUser,
  'icon-user-music': IconUserMusician,
  'icon-award': IconAward,
  'icon-leaf': IconLeaf,
  'icon-bolt': IconBolt,
  'icon-bullseye': IconBullseye,
  'icon-ruler-combined': IconRulerCombined,
  'icon-signal-stream': IconSignalStream,
  'icon-mind-oasis': IconMindOasis,
  'icon-minus': IconMinus,
  'icon-plus': IconPlus,
  'icon-box-check': IconBoxCheck,
  'icon-dropdown': IconDropdown,
  'icon-check': IconCheck,
  'icon-lock': IconLock,
  'icon-chevron-left': IconChevronLeft,
  'icon-chevron-right': IconChevronRight,
  'icon-trash': IconTrash,
  'icon-eye-slash': IconEyeSlash,
  'icon-eye': IconEye,
  'icon-arrow-left': IconArrowLeft,
  'icon-sign-in': IconSignIn,
  'icon-info': IconInfo,
  'icon-apple': IconApple,
  'icon-google': IconGoogle,
  'icon-music-magnifying-glass': IconMusicMagnifyingGlass,
  'icon-plug-circle-check': IconPlugCircleCheck,
  'icon-circle-question': IconCircleQuestion,
  'icon-download': IconDownToLine,
  'icon-reply': IconReply,
  'icon-headspace': IconHeadspace,
  'icon-house': IconHouse,
  'icon-circle-check': IconCircleCheck,
  'icon-circle-exclamation': IconCircleExclamation,
  'icon-circle-xmark': IconCircleXmark,
  'icon-triangle-exclamation': IconTriangleExclamation,
  'icon-play': IconPlay,
  'icon-pause': IconPause,
  'icon-pen': IconPen,
  'icon-power-off': IconPowerOff,
  'icon-power-off-light': IconPowerOffLight,
  'icon-quote-left': IconQuoteLeft,
  'icon-quote-right': IconQuoteRight,
  'icon-sliders-simple': IconSlidersSimple,
  'icon-bag': IconBag,
  'icon-bags-shopping': IconBagsShopping,
  'icon-x-mark': IconXMark,
  'icon-comment-question': IconCommentQuestion,
  'icon-search': IconSearch,
  'icon-arrow-rotate-left': IconArrowRotateLeft,
  'icon-expand': IconExpand,
  'icon-volume': IconVolume,
  'icon-volume-xmark': IconVolumeXMark,
  'icon-barcode-read': IconBarcodeRead,
  'icon-envelope': IconEnvelope,
  'icon-list-check': IconListCheck,
  'icon-user-magnifying-glass': IconUserMagnifyingGlass,
  'icon-arrow-pointer': IconArrowPointer,
  'icon-image': IconImage,
  'icon-insight-timer': IconInsightTimer,
  'icon-box-taped': IconBoxTaped,
  'icon-moon': IconMoon,
  'icon-wave-sine': IconWaveSine,
  'icon-location-dot': IconLocationDot,
  'icon-line-arrow-right': IconLineArrowRight,
  'icon-link-slash': IconLinkSlash,
  'icon-light-circle-user': IconLightCircleUser,
  'icon-light-globe': IconLightGlobe,
  'icon-light-cart': IconLightCart,
  'icon-waveform': IconWaveform,
};

// Images
const images = {
  'image-logo': ImageLogo,
  'image-b-corporation-badge': ImageBCorporationBadge,
  'image-vogue': ImageVogue,
  'image-logo-home': ImageLogoHome,
  'image-mastercard': ImageMastercard,
  'image-visa': ImageVisa,
  'image-paypal': ImagePayPal,
  'image-ideal': ImageIdeal,
  'image-amex': ImageAmex,
  'image-rituals-cta-icon': ImageRitualsCtaIcon,
  'image-rituals-primary-logo': ImageRitualsPrimaryLogo,
  'image-google-logo': ImageGoogleLogo,
};

export type IconName = keyof typeof icons;
type ImageName = keyof typeof images;
export type VectorName = IconName | ImageName;

const vector: Record<VectorName, FC<SVGProps<SVGElement>>> = {
  ...icons,
  ...images,
};

type Props = {
  name?: VectorName;
  className?: string;
  ariaHidden?: boolean;
};

const VectorGraphic: FC<Props> = ({ name, className, ariaHidden }: Props) => {
  if (!name) return null;

  const Vector = vector[name];

  if (typeof Vector === 'undefined') return null;

  return <Vector className={cn(className)} aria-hidden={ariaHidden} />;
};

export default VectorGraphic;
